import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CyclopsHttp } from './app.http';

@Injectable({
  providedIn: 'root',
})
export class AumyeAnalyticsService {
  constructor(private cyclopsHttp: CyclopsHttp) {}
  onGetVisitorTickets(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetVisitorTickets', params);
  }
  onGetIncidentTickets(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetIncidentTickets', params);
  }
  onCreateVisitorTicket(params: any): Observable<any> {
    return this.cyclopsHttp.post('VisitorTicket', params);
  }
  onCreateIncidentTicket(params: any) {
    return this.cyclopsHttp.post('IncidentTicket', params);
  }
  onGetComplaintsTickets(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetUserComplaints', params);
  }
  onGetClaimTickets(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetUserClaims', params);
  }
  onGetRequestTickets(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetUserRequests', params);
  }
  onSaveRiskProfileQuestions(params: any): Observable<any> {
    return this.cyclopsHttp.post('SaveRiskQuestions', params);
  }
  onGetRiskProfileQuestions(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetRiskData?startDate=2025-08-01&period=year', params);
  }
  onGetRiskProfileNew(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetRiskDataNew', params);
  }
  onGetVisitorAnalytics(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetVisitorAnalytics', params);
  }
}
